module.exports = __webpack_public_path__ + "static/media/gts29.55756451.png";